
import { debugLog, DebugLevel } from "@/utils/debugUtils";
import { attemptFocusAndScroll } from "@/utils/uiUtils";

/**
 * Manages UI interactions during round preparation
 */
export const handleUiFocus = (
  setShouldAutoFocus: (shouldAutoFocus: boolean) => void
): void => {
  // Immediately set autoFocus flag to trigger focus in the component
  setShouldAutoFocus(true);
  debugLog(DebugLevel.INFO, "roundPreparation", "Set shouldAutoFocus to true");

  // Step 1: First focus without scrolling, then use smooth scroll
  attemptFocusAndScroll(1, true); // Pass true to enable smooth scrolling
  debugLog(DebugLevel.INFO, "roundPreparation", "Initial attemptFocusAndScroll called with smooth scrolling");
  
  // Make another attempt after UI update (still with smooth scrolling)
  setTimeout(() => {
    attemptFocusAndScroll(3, true);
    debugLog(DebugLevel.INFO, "roundPreparation", "Delayed attemptFocusAndScroll called with smooth scrolling");
  }, 300);
};

/**
 * Handles errors during round preparation with toast notifications
 */
export const handleRoundPreparationError = (
  errorType: string,
  toast: any
): void => {
  switch (errorType) {
    case 'proximity':
      toast({
        variant: "destructive",
        title: "Error",
        description: "There was a problem calculating word proximity."
      });
      break;
    case 'ai-word':
      toast({
        variant: "destructive",
        title: "Error",
        description: "There was a problem generating the AI's next word."
      });
      break;
    case 'saving-word':
      toast({
        variant: "destructive",
        title: "Error",
        description: "There was a problem saving the bot's word."
      });
      break;
    default:
      toast({
        variant: "destructive",
        title: "Error",
        description: "There was a problem preparing the next round."
      });
  }
};
